import graphqlResource, {
  GraphqlResource,
} from '../../../core/graphqlResource';
import { UpsertTournamentApplicationUserDto } from '../dtos/UpsertTournamentApplicationUser.dto';
import { TournamentUser } from '../interfaces/TournamentUser';
import { UpsertTournamentApplicationUserResponseDto } from '../dtos/UpsertTournamentApplicationUserResponse.dto';
import { AddToTeamInputDto } from '../dtos/AddToTeamInput.dto';
import { AddToTeamInputResponseDto } from '../dtos/AddToTeamInputResponse.dto';
import { KickFromTeamInputDto } from '../dtos/KickFromTeamInput.dto';
import { DeleteTournamentApplicationUserResponseDto } from '../dtos/DeleteTournamentApplicationUserResponse.dto';
import { GetTeamPlayersResponseDto } from '../dtos/GetTeamPlayersResponse.dto';
import { GetUserResponseDto } from '../dtos/GetUserResponse.dto';

export class PlayersRepository {
  constructor(private readonly graphql: GraphqlResource) {}

  public async getTournamentUsers(params: number): Promise<TournamentUser[]> {
    const query = `
      query team($id: Int!) {
        team(id: $id) {
          members {
            id
            user {
              id
              name
              surname
              middleName
              birthDate
              height
              weight
              tournamentAvatars {
                id
                image {
                  id
                  externalUrl
                }
              }
            }
          }
        }
      }
    `;
    const response = await this.graphql.query<GetTeamPlayersResponseDto>(
      query,
      { id: params }
    );
    const { members } = response.data.data.team;
    const players = members.map((teamMember) => {
      return { /* position: teamMember.position, */ ...teamMember.user };
    });

    return players;
  }

  public async getUser(params: number): Promise<TournamentUser> {
    const query = `
      query user($id: Int!) {
        user(id: $id) {
          id
          name
          surname
          middleName
          birthDate
          height
          weight
          tournamentAvatars {
            id
            image {
              id
              externalUrl
            }
          }
        }
      }
    `;
    const response = await this.graphql.query<GetUserResponseDto>(query, {
      id: params,
    });
    const { user } = response.data.data;

    return user;
  }

  public async upsertTournamentApplicationForUser(
    params: UpsertTournamentApplicationUserDto,
    tournamentId: number
  ): Promise<TournamentUser> {
    const query = `
      mutation upsertTournamentUser($input: CreateUserInput!, $tournamentId: Int!) {
        upsertTournamentUser(input: $input, tournamentId: $tournamentId) {
          id
          name
          surname
          middleName
          birthDate
          height
          weight
          createdAt
          tournamentAvatars {
            id
            image {
              id
              externalUrl
            }
          }
        }
      }
    `;

    const variables = {
      input: {
        ...params,
        // position: params.position
        //   ? params.position.toUpperCase()
        //   : params.position,
      },
      tournamentId,
    };
    const response =
      await this.graphql.query<UpsertTournamentApplicationUserResponseDto>(
        query,
        variables
      );
    const { upsertTournamentUser } = response.data.data;
    const {
      id,
      name,
      middleName,
      surname,
      birthDate,
      height,
      weight,
      // position,
      tournamentAvatars,
    } = upsertTournamentUser;

    return {
      id,
      name,
      middleName,
      surname,
      birthDate,
      height,
      weight,
      // position,
      tournamentAvatars,
      createdAt: new Date(upsertTournamentUser.createdAt),
    };
  }

  public async addUserToTeam(
    params: AddToTeamInputDto
  ): Promise<TournamentUser> {
    const query = `
      mutation addToTeam($input: AddToTeamInput!) {
        addToTeam(input: $input) {
          id
          name
          surname
          middleName
          birthDate
          photo {
            id
            externalUrl
          }
          height
          weight
          createdAt
          tournamentAvatars {
            id
            image {
              id
              externalUrl
            }
          }
        }
      }
    `;

    const variables = {
      input: {
        ...params,
        // position: params.position
        //   ? params.position.toUpperCase()
        //   : params.position,
      },
    };

    const response = await this.graphql.query<AddToTeamInputResponseDto>(
      query,
      variables
    );
    const { addToTeam } = response.data.data;
    const {
      id,
      name,
      middleName,
      surname,
      birthDate,
      height,
      weight,
      tournamentAvatars,
    } = addToTeam;

    return {
      id,
      name,
      middleName,
      surname,
      birthDate,
      height,
      weight,
      // position: params.position,
      tournamentAvatars,
      createdAt: new Date(addToTeam.createdAt),
    };
  }

  public async deleteTournamentApplicationUser(
    params: number
  ): Promise<string> {
    const query = `
      mutation deleteTournamentUser($userId: Int!) {
        deleteTournamentUser(userId: $userId) {
          status
        }
      }
    `;

    const response =
      await this.graphql.query<DeleteTournamentApplicationUserResponseDto>(
        query,
        { userId: params }
      );
    const { status } = response.data;

    return status;
  }

  public async kickUserFromTeam(
    params: KickFromTeamInputDto
  ): Promise<Boolean> {
    const query = `
    mutation kickFromTeam($teamId: Int!, $userId: Int!) {
      kickFromTeam(teamId: $teamId, userId: $userId)
    }
    `;

    const response = await this.graphql.query<Boolean>(query, params);
    const result = response.data;

    return result;
  }
}

const playersRepository = new PlayersRepository(graphqlResource);

export default playersRepository;
